module.exports = __webpack_public_path__ + "static/img-7.69e38a45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/office_img/img-7.jpg
// module id = 903
// module chunks = 41802369688294